<template>
  <div>
    <v-layout row wrap>
      <v-col :cols="isMobile ? 12 : 3" class="mt-6 mx-6">
        <div class="card-footer bg-light">
          <v-autocomplete
            class="mb-4"
            @change="getSelectedDivision"
            v-model="division"
            :items="divisions"
            dense
            color="teal"
            filled
            label="Select Products Or Services"
          ></v-autocomplete>

          <v-autocomplete
            v-if="division"
            class="mb-4"
            v-model="action"
            :items="[
              'View ' + division,
              'Create ' + division,
              'Add ' + division + ' To Receivings',
              'View Inventory Table',
            ]"
            dense
            color="teal"
            filled
            label="Select Action To Perform"
          ></v-autocomplete>

          <v-autocomplete
            v-if="
              action &&
              (action == 'View ' + division ||
                action == 'Add ' + division + ' To Receivings') &&
              items &&
              items.length > 0
            "
            v-model="selectedItemID"
            :items="items"
            item-text="name"
            item-value="id"
            dense
            filled
            color="teal"
            :label="'Select ' + division"
            @change="getSelectedItemID"
          ></v-autocomplete>
          <div
            v-if="
              division &&
              action &&
              action == 'View ' + division &&
              selectedItemID
            "
          >
            <FileUpload
              @image-uploaded="getNewImages"
              :imagePath="selectedItem.imagePath"
              :imageName="selectedItem.link + '-' + '1'"
              :imageFolder="
                'images/items/' + getUserCompany.emis + '/' + selectedItem.link
              "
              v-if="division"
              :profilePicture="false"
            ></FileUpload>
            <div
              class="text-center"
              v-if="
                selectedItem &&
                selectedItem.imagePath &&
                selectedItem.imagePath.includes('https://')
              "
            >
              <v-btn
                x-small
                outlined
                fab
                color="red"
                @click="deleteImage(selectedItem.images[0])"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <ProductInventory
              class="my-4"
              :productProp="selectedItem"
              v-if="division == 'Products'"
            ></ProductInventory>
          </div>

          <div v-if="division && action && action == 'Create ' + division">
            <CreateProduct
              v-if="division == 'Products'"
              @product-created="getAllProducts"
            ></CreateProduct>
            <CreateService
              v-else
              @service-created="getAllServices"
            ></CreateService>
          </div>

          <div
            v-if="
              division &&
              action &&
              action == 'Add ' + division + ' To Receivings'
            "
          >
            <AddProductsToReceivings
              :item="selectedItem"
              @receivings-added="getInventoryForProduct"
              @supplier-selected="takeActionAfterSupplierSelected"
              :newlyCreatedSupplier="newlyCreatedSupplier"
            ></AddProductsToReceivings>
            <CreateSupplier
              v-if="showCreateSupplier && division == 'Products'"
              @supplier-created="getNewlyCreatedSupplier"
            ></CreateSupplier>
            <CreateServiceProvider
              v-else-if="division == 'Services'"
            ></CreateServiceProvider>
          </div>
        </div>
      </v-col>
      <v-col :cols="isMobile ? 12 : 8">
        <div v-if="action == 'View Inventory Table'">
          <InventoryTable class="mt-6"></InventoryTable>
        </div>
        <div v-else>
          <ItemDetail
            v-if="selectedItem && selectedItem.link"
            :itemProp="selectedItem"
            :division="division"
            class="mt-6"
          ></ItemDetail>
        </div>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
//@ts-ignore
import helpersJs from "@/plugins/helpers";
import imagesJs from "@/plugins/images";
import productsAndServicesJs from "@/plugins/productsAndServices";
import FileUpload from "@/components/myLibrary/FileUpload.vue";
import ItemDetail from "./ItemDetail.vue";
import CreateProduct from "./CreateProduct.vue";
import CreateService from "./CreateService.vue";
import CreateSupplier from "./CreateSupplier.vue";
import CreateServiceProvider from "./CreateServiceProvider.vue";
import AddProductsToReceivings from "./AddProductsToReceivings.vue";
import ProductInventory from "./ProductInventory.vue";
import InventoryTable from "./InventoryTable.vue";

export default {
  components: {
    FileUpload,
    ItemDetail,
    CreateProduct,
    CreateService,
    AddProductsToReceivings,
    CreateSupplier,
    CreateServiceProvider,
    ProductInventory,
    InventoryTable,
  },
  watch: {
    division() {
      this.selectedItemID = null;
      this.items = [];
    },
  },

  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getPlaceholderImage() {
      return this.$store.getters.getPlaceholderImage;
    },
  },
  data: () => ({
    action: null,
    divisions: ["Products", "Services"],
    suppliers: [],
    showCreateSupplier: false,
    newlyCreatedSupplier: null,
    serviceProviders: [],
    inventory: [],
    category_id: "",
    items: [],
    selectedItemID: null,
    name: "",
    selectedItem: {
      name: "",
      list_on_store: "",
      description: "",
      category_id: "",
      cost_per_unit: "",
      cost: "",
      serviceFee: "",
      stock: 1,
      link: null,
    },
    division: "",
  }),
  methods: {
    setCategory(categoryID) {
      this.selectedItem["category_id"] = categoryID[0];
    },
    stripCommasFromMoney(amount) {
      return helpersJs.stripCommasFromMoney(amount);
    },
    async getAllProducts() {
      const products = await productsAndServicesJs.getAllProducts();
      return products;
    },
    async getAllServices() {
      const services = await productsAndServicesJs.getAllServices();
      return services;
    },
    getNewlyCreatedSupplier(newlyCreatedSupplier) {
      this.newlyCreatedSupplier = newlyCreatedSupplier;
    },
    getInventoryForProduct() {
      //console.log(inventoryForProduct)
    },
    async getSelectedDivision() {
      this.$store.commit("setLoader", true);
      this.items = [];
      if (this.division == "Products") {
        this["category_id"] = "Products";
        this.items = await this.getAllProducts();
        this.$store.commit("setLoader", false);
      } else if (this.division == "Services") {
        this["category_id"] = "Services";
        this.items = await this.getAllServices();
        this.$store.commit("setLoader", false);
      } else {
        this.items = [];
      }
    },
    getSelectedItemID() {
      this.selectedItem = this.items.find((item) => {
        return item.id == this.selectedItemID;
      });
    },
    getNewImages(images) {
      if (images.length > 0) {
        this.selectedItem.images = [];
        for (let i = 0; i < images.length; i++) {
          this.selectedItem.push(
            this.getApiUrl +
              "/images/items/" +
              this.getUserCompany.emis +
              "/" +
              images[i]
          );
        }
      } else {
        this.selectedItem.images = [this.getPlaceholderImage];
      }
    },
    async deleteImage(imagePath) {
      this.$store.commit("setLoader", true);

      const parts = imagePath.split("/");
      const imageName = parts[parts.length - 1];

      const imageFolderPathWithinPublic =
        "images/items/" +
        this.getUserCompany.emis +
        "/" +
        this.selectedItem.link;
      const images = await imagesJs.deleteImage(
        imageFolderPathWithinPublic,
        imageName
      );

      this.selectedItem.images = await imagesJs.getImagesPublicFullPath(
        imageFolderPathWithinPublic,
        images
      );

      this.$store.commit("setLoader", false);
    },
    takeActionAfterSupplierSelected(selectedSupplier) {
      if (
        selectedSupplier &&
        selectedSupplier.name &&
        selectedSupplier.name.includes("Add New")
      ) {
        this.showCreateSupplier = true;
      } else {
        this.showCreateSupplier = false;
      }
    },
  },
};
</script>
